import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AnchorResult, PhraseWord, ReferenceIssue, ReferencePhrase } from 'src/app/shared/models/common';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from 'src/app/shared/services/shared.service';
//import { IndPhrase } from 'src/app/shared/models/cat.model';
import { WrappedNodeExpr } from '@angular/compiler';
import { EmbeddedObjectAnnotation } from '@shared/models/embedded-object-annotation';
import { CatDoc, IndPhrase, ReferenceDocument } from '@shared/models/cat.model';
import { getObjectPropValue } from '@shared/utils';
import { AppState } from '@shared/redux/store';
import { NgRedux } from '@shared/redux/redux-compatibility.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'phrase-ref',
    templateUrl: './cat-phrase-ref.component.html',
    styleUrls: ['./cat-phrase-ref.component.scss'],
    standalone: false
})
export class CatPhraseRefComponent implements OnInit, OnDestroy {
  @Input() ref: ReferencePhrase;
  @Input() editable: boolean;
  @Input() allowEdit: boolean;
  @Input() disableConsistencyCheckResultsActions: boolean = false;
  @Input() showDelete: boolean = true;
  @Input() showEdit: boolean = true;
  @Input() mainPhrase: IndPhrase;
  @Input() curCatDoc: CatDoc | undefined; 
  @Input () mainPhraseWords: PhraseWord[] = [];
  @Input() disabled: boolean = false;
  @Input() showAddAnchors: boolean = true;
  @Input() displayActionsForUpdatingAnchors = true;
  @Input() showMatchSimilarityCode: boolean = true;
  @Input() saveOriginalOnInit: boolean = true;

  @Input() showReferenceIssueType: boolean = false;
  @Input() referenceIssue: ReferenceIssue | null = null;
  @Input() refDoc: ReferenceDocument | null = null;
  @Input() addedConsistencyGeneratedReference: boolean = false;

  @Input() matchedRef: ReferencePhrase = null;

  @Output() onRefChanged = new EventEmitter();
  @Output() onDeleteRef = new EventEmitter();

  @Output() viewPageAndRefEmitter = new EventEmitter();

  @Output() removeAnchorEmitter = new EventEmitter();
  editMode: boolean;
  displayEditBtn: boolean;

  phraseWords: PhraseWord[] = [];
  
  pointerWord: PhraseWord;
  displayPointerWordList: boolean;
  disableUserActions = false;

  showRefDoc: boolean = false;
  showAddContextDropdown: {
    value: boolean
  } = {
    value: false
  };
  destroy$ = new Subject();
  
  constructor(
    private ngRedux: NgRedux<AppState>,
    private translateService: TranslateService,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    if (this.saveOriginalOnInit) {
      this.ref.saveOriginal();
    }
    this.sharedService.checkConsistencyCheckResultsPanelClose?.pipe(takeUntil(this.destroy$)).subscribe(() => {

      this.closeConsistencyCheckResultPanels();
    })
    if (this.editable && !this.ref.refPhraseId) {
      this.editMode = true;
    }
    if (this.ref.pointerWordId != null) {
      this.pointerWord = this.mainPhraseWords.find(
        (w) => w.id == this.ref.pointerWordId
      );
    }
    //Object.assign(this.mainPhraseWords, this.mainPhrase.phraseWords);
    const uiConfig = this.ngRedux.getState().uiConfig;
    if (uiConfig) {

      const user_action_buttons_enabled_when_dirty = getObjectPropValue(uiConfig, 'rule_details_config.user_action_buttons_enabled_when_dirty');
      if (user_action_buttons_enabled_when_dirty != undefined) {

        this.disableUserActions = !user_action_buttons_enabled_when_dirty;
      }
    }
  }

  ngOnDestroy(): void {

      this.destroy$.next();
      this.destroy$.complete();
  }

  markChanges() {
    this.onRefChanged.emit();
  }

  discardChanges() {
    this.ref.restoreOriginal();
    this.editMode = false;
    this.ref.saveOriginal();
  }

  toggleAddContextDropdown() {

    this.showAddContextDropdown.value = !this.showAddContextDropdown.value;

  }

  onDeleteClicked() {
    if (!this.ref.refPhraseId) {
      this.onDeleteRef.emit();
      return;
    }

    let validationStr = this.translateService.instant(
      'translate.cat.deleteReference'
    );

    this.sharedService.emitPopupchReceivedEvent({
      title: 'translate.validation.confirm',
      icon: 'exclamation-triangle',
      subTitle: validationStr,
      keep: false,
      approve: () => {
        this.onDeleteRef.emit();
      },
    });
  }

  onWordChanged() {
    this.markChanges();
    this.ref.pointerWordId = this.pointerWord.id;
    this.displayPointerWordList = false;
  }
  viewPageAndRef(embeddedObjectAnnotation: EmbeddedObjectAnnotation) {
    
    this.viewPageAndRefEmitter.emit(embeddedObjectAnnotation);
  }
  toggleDisplayAnchors() {
    this.ref.showAnchors = !this.ref.showAnchors;
  }


  isAddAnchorsDisabled(): boolean {
    return getObjectPropValue(this.ngRedux.getState().uiConfig, 'anchors.add_anchors_disabled') ?? false;
  }
  closeConsistencyCheckResultPanels() {

      if (this.disableUserActions) {
        
        this.showAddContextDropdown.value = false;
      }
  }
}
